module.exports = __webpack_public_path__ + "img/guide1_m.735fb932.jpg";